<template>
	<div class="parts-locations-general-card-edit">
		<!-- Shared Settings Section -->
		<SectionContainer>
			<template #left>
				<h4>Shared Settings</h4>
			</template>
			<template #content>
				<Dropdown
					label="RO Default Advisor"
					subLabel="Affects Estimate and RO"
					v-model="localData.sharedSettings.roDefaultAdvisor"
					:options="roDefaultAdvisorTypeOptions"
				/>
				<Textarea
					label="RO Concern"
					subLabel="After Estimate and RO"
					:cols="30"
					maxlength="200"
					v-model="localData.sharedSettings.roConcern"
				/>
				<label for="multipleDeptTypes">
					<span>Multiple Dept Types</span>
					<span>
						Affects Appointment; Estimate; and Repair Order.
					</span>
				</label>
				<Toggle
					id="multipleDeptTypes"
					v-model="localData.sharedSettings.multipleDeptTypes"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<!-- DEV NOTE: do we want to add the type %? -->
				<Dropdown
					label="Default Notify By"
					subLabel="Affects Estimate and RO"
					v-model="localData.sharedSettings.defaultNotifyBy"
					:options="defaultNotifyByTypeOptions"
				/>
				<Input
					label="Paint & Supply Markup"
					sublabel="Affects Estimate and RO"
					v-model="localData.sharedSettings.paintAndSupplyMarkup"
				/>
				<label for="autoVis">
					<span>Auto VIS</span>
					<span>
						Affects Appointment; Estimate; and Repair Order.
					</span>
				</label>
				<Toggle
					id="autoVis"
					v-model="localData.sharedSettings.autoVis"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
			</template>
		</SectionContainer>
		<!-- Appointment Section -->
		<SectionContainer>
			<template #left>
				<h4>Appointment</h4>
			</template>
			<template #content>
				<Dropdown
					label="Appt Default Advisor"
					v-model="localData.appointment.defaultAdvisor"
					:options="defaultAdvisorTypeOptions"
				/>
				<label for="requireOpCodes">
					<span>Require Appt Advisor</span>
				</label>
				<Toggle
					id="requireOpCodes"
					v-model="localData.repairOrder.requireOpCodes"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
			</template>
		</SectionContainer>
		<!-- Estimate -->
		<SectionContainer>
			<template #left>
				<h4>Estimate</h4>
			</template>
			<template #content>
				<!-- DEV NOTE: to replace for inline-edit -->
				<Input
					label="Next Estimate"
					v-model="localData.estimate.nextEstimate"
				/>
				<Input
					label="# Of Days to Expire"
					v-model="localData.estimate.numberOfDaysToExpire"
				/>
			</template>
		</SectionContainer>
		<!-- RO Section -->
		<SectionContainer>
			<template #left>
				<h4>RO</h4>
			</template>
			<template #content>
				<Dropdown
					label="Require Op Codes"
					sublabel="Lorem ipsum ut semper et ipsum at cursus"
					v-model="localData.repairOrder.requireOpCodes"
					:options="requireOpCodesTypeOptions"
				/>
				<!-- DEV NOTE: create time component -->
				<label for="promiseTime">Promise Time</label>
				<input
					id="promiseTime"
					type="time"
					v-model="localData.repairOrder.roPromiseTime"
				/>
				<!-- DEV NOTE: create inline edit input component -->
				<label for="promiseTime">Next Repair Order</label>
				<input />
				<section>
					<h6>Auto Assign</h6>
					<Dropdown
						label="Auto Assign Actual With"
						sublabel="Lorem ipsum ut semper et ipsum at cursus"
						v-model="localData.repairOrder.autoAssignActualWith"
						:options="autoAssignActualWithTypeOptions"
					/>
					<label for="autoAssignActualHours">
						<span>Auto Assign Actual Hours</span>
						<span>
							Lorem ipsum ut semper et ipsum at cursus
						</span>
					</label>
					<Toggle
						id="autoAssignActualHours"
						v-model="localData.repairOrder.autoAssignActualHours"
						:isLabelBefore="true"
					>
						<template slot="true-value">YES</template>
						<template slot="false-value">NO</template>
					</Toggle>
				</section>
				<section>
					<h6>Parts</h6>
					<Dropdown
						label="Part Request Send To"
						sublabel="Lorem ipsum ut semper et ipsum at cursus"
						v-model="localData.repairOrder.partRequestSendTo"
						:options="partRequestSendToTypeOptions"
					/>
					<label for="partsCanRecoverOps">
						<span>Parts Can Recover Ops</span>
						<span>
							Lorem ipsum ut semper et ipsum at cursus
						</span>
					</label>
					<Toggle
						id="partsCanRecoverOps"
						v-model="localData.repairOrder.partsCanRecoverOps"
						:isLabelBefore="true"
					>
						<template slot="true-value">YES</template>
						<template slot="false-value">NO</template>
					</Toggle>
					<label for="editFixedPriceParts">
						<span>Edit Fixed Price Parts</span>
						<span>
							Lorem ipsum ut semper et ipsum at cursus
						</span>
					</label>
					<Toggle
						id="editFixedPriceParts"
						v-model="localData.repairOrder.editFixedPriceParts"
						:isLabelBefore="true"
					>
						<template slot="true-value">YES</template>
						<template slot="false-value">NO</template>
					</Toggle>
				</section>
				<section>
					<h6>Work Order</h6>
					<Dropdown
						label="Release Button Actions"
						sublabel="Lorem ipsum ut semper et ipsum at cursus"
						v-model="localData.repairOrder.releaseButtonActions"
						:options="releaseButtonActionsTypeOptions"
					/>
					<label for="attachWOonRelease">
						<span>Attach WO on Release</span>
						<span>
							Lorem ipsum ut semper et ipsum at cursus
						</span>
					</label>
					<Toggle
						id="attachWOonRelease"
						v-model="localData.repairOrder.attachWOonRelease"
						:isLabelBefore="true"
					>
						<template slot="true-value">YES</template>
						<template slot="false-value">NO</template>
					</Toggle>
				</section>
				<label for="requireTechnician">
					<span>Require Technician</span>
					<span>
						Lorem ipsum ut semper et ipsum at cursus
					</span>
				</label>
				<Toggle
					id="requireTechnician"
					v-model="localData.repairOrder.requireTechnician"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<label for="updateMileage">
					<span>Require Technician</span>
					<span>
						Lorem ipsum ut semper et ipsum at cursus
					</span>
				</label>
				<Toggle
					id="updateMileage"
					v-model="localData.repairOrder.roUpdateMileage"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<section>
					<h6>Hours</h6>
					<label for="warrantyAndFlagHoursValidation">
						<span>Warranty & Flag Hours Validation</span>
						<span>
							Lorem ipsum ut semper et ipsum at cursus
						</span>
					</label>
					<Toggle
						id="warrantyAndFlagHoursValidation"
						v-model="
							localData.repairOrder.warrantyAndFlagHoursValidation
						"
						:isLabelBefore="true"
					>
						<template slot="true-value">YES</template>
						<template slot="false-value">NO</template>
					</Toggle>
					<label for="payByActualHours">
						<span>Pay By Actual Hours</span>
					</label>
					<Toggle
						id="payByActualHours"
						v-model="localData.repairOrder.payByActualHours"
						:isLabelBefore="true"
					>
						<template slot="true-value">YES</template>
						<template slot="false-value">NO</template>
					</Toggle>
					<label for="showActualHours">
						<span>Show Actual Hours</span>
					</label>
					<Toggle
						id="showActualHours"
						v-model="localData.repairOrder.showActualHours"
						:isLabelBefore="true"
					>
						<template slot="true-value">YES</template>
						<template slot="false-value">NO</template>
					</Toggle>
				</section>
				<section>
					<h6>Prompts</h6>
					<label for="printPoPrompt">
						<span>Print PO Prompt</span>
					</label>
					<Toggle
						id="printPoPrompt"
						v-model="localData.repairOrder.printPoPrompt"
						:isLabelBefore="true"
					>
						<template slot="true-value">YES</template>
						<template slot="false-value">NO</template>
					</Toggle>
					<label for="subletPrompt">
						<span>Sublet Prompt</span>
					</label>
					<Toggle
						id="subletPrompt"
						v-model="localData.repairOrder.subletPrompt"
						:isLabelBefore="true"
					>
						<template slot="true-value">YES</template>
						<template slot="false-value">NO</template>
					</Toggle>
				</section>
				<section>
					<h6>Imported Operations Order Source</h6>
					<p>Lorem ipsum ut semper et ipsum at cursus</p>
					<ul>
						<li
							v-for="(item, index) in localData.repairOrder
								.importedOpOrderSourceManufacturer"
							:key="index"
						>
							<Dropdown
								v-model="item.source"
								:options="sourceTypeOptions"
							/>
							<Dropdown
								v-model="item.manufacturer"
								:options="manufacturerTypeOptions"
							/>
							<Button
								labelText="Delete"
								iconClassName="icon-history"
								:iconBeforeLabel="true"
							/>
						</li>
					</ul>
					<Button
						labelText="Add"
						iconClassName="icon-history"
						:iconBeforeLabel="true"
					/>
				</section>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import Input from '@/components/forms/input/input';
import Textarea from '@/components/forms/textarea/textarea.vue';
import Toggle from '@/components/forms/selection-control/toggle/toggle';
import Button from '@/components/forms/button/button';
import SectionContainer from '@/components/shells/section-container/section-container';
import _ from 'lodash';

export default {
	name: 'PartsLocationsGeneralCardEdit',
	components: {
		SectionContainer,
		Dropdown,
		Textarea,
		Input,
		Toggle,
		Button
	},
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value),
			defaultNotifyByTypeOptions: ['lorem', 'ipsum', 'dolor'],
			roDefaultAdvisorTypeOptions: ['lorem', 'ipsum', 'dolor'],
			defaultAdvisorTypeOptions: ['lorem', 'ipsum', 'dolor'],
			requireOpCodesTypeOptions: ['lorem', 'ipsum', 'dolor'],
			autoAssignActualWithTypeOptions: ['lorem', 'ipsum'],
			partRequestSendToTypeOptions: ['lorem', 'ipsum', 'dolor'],
			releaseButtonActionsTypeOptions: ['lorem', 'ipsum', 'dolor'],
			sourceTypeOptions: ['Kia', 'Hyundai', 'GMC'],
			manufacturerTypeOptions: ['X - Kia Parts', 'X - Hyunday']
		};
	},
	created() {
		//console.log(this.value);
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.$emit('update', this.localData);
				this.$emit('input', this.localData);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.parts-locations-general-card-edit {
	&__item {
		display: block;
	}
}
</style>
